import React from 'react';
import { LocalePreferenceContext } from '../context/localePreference';

export function useLocalePreferenceContext() {
  return React.useContext(LocalePreferenceContext);
}
